import { render, staticRenderFns } from "./SecondExtras.vue?vue&type=template&id=72b17cb0&"
import script from "./SecondExtras.vue?vue&type=script&lang=js&"
export * from "./SecondExtras.vue?vue&type=script&lang=js&"
import style0 from "./SecondExtras.vue?vue&type=style&index=0&id=72b17cb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports